const allowedTypes = [
    "banner",
    "modal",
    "inline",
    "info-box"
];
function isTemplateType(value) {
    return allowedTypes.includes(value);
}
export class TemplateResolver {
    static resolve(action) {
        const html = action === null || action === void 0 ? void 0 : action.html;
        if (!html)
            return "banner";
        const temp = document.createElement("div");
        temp.innerHTML = html.trim();
        const element = temp.querySelector("[data-display-type]");
        if (!element)
            return "banner";
        const displayType = element.getAttribute("data-display-type");
        return isTemplateType(displayType) ? displayType : "banner";
    }
}
